import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type InfoTextProps = {
    text: string;
};
const InfoText: FC<InfoTextProps> = ({ text }: InfoTextProps) => {
    return (
        <Box display="flex" alignItems="center" my={1}>
            <InfoOutlinedIcon sx={{ marginRight: 0.5, opacity: 0.5 }} color="info" />
            <Typography variant="body2" color="grey">
                {text}
            </Typography>
        </Box>
    );
};

export default InfoText;
